// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatFilterKey = (searchOptions: any, filterValue: any) => {
  const filterKey = searchOptions.filter(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (option: any) => option.value === filterValue
  );
  return filterKey[0].key;
};
